<template>
  <div class="ins-main rbcn-main">
    <h1 class="rbcn-head groupHeading">{{this.$t('lang_men_labelSolution')}}</h1>
    <section class="rbcn-pro">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_productAdvantage')}}</span>
      </div>
      <div class="rbcn-description themeDesc" v-html="this.$t('lang_labelSolution_productAdvantage_narrative')">
      </div>
      <template v-if="isMobile">
        <div class="rbcn-banner">
          <carousel ref="carousel"
            :perPage="1" 
            :mouse-drag="false" 
            :navigationEnabled="false" 
            :paginationEnabled="true" 
            :loop="true"
            class="rbcn-slider"
          >
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-1"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort1')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_1.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort1_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-2"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort2')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_2.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort2_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-3"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort3')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_3.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort3_list')"></ol>
            </slide>
            <slide class="rbcn-slider-item">
              <div class="rbcn-pro-mobile rbcn-pro-4"></div>
              <span>{{this.$t('lang_labelSolution_productAdvantage_sort4')}}</span>
              <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_4.png" alt=""></div>
              <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort4_list')"></ol>
            </slide>
          </carousel>
          <a @click.prevent="prevSlide" class="prev-btn">
            <img :src='require(`@img/develop/photoarrow.png`)'>
          </a>
          <a @click.prevent="nextSlide" class="next-btn">
            <img :src='require(`@img/develop/photoarrow.png`)'>
          </a>
        </div>
      </template>
      <template v-else>
        <ul class="rbcn-pro-item clearfix">
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-1"></div>
            <span>{{this.$t('lang_labelSolution_productAdvantage_sort1')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_1.png" alt=""></div>
            <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort1_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-2"></div>
            <span>{{this.$t('lang_labelSolution_productAdvantage_sort2')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_2.png" alt=""></div>
            <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort2_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-3"></div>
            <span>{{this.$t('lang_labelSolution_productAdvantage_sort3')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_3.png" alt=""></div>
            <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort3_list')"></ol>
          </li>
          <li>
            <div class="rbcn-pro-mobile rbcn-pro-4"></div>
            <span>{{this.$t('lang_labelSolution_productAdvantage_sort4')}}</span>
            <div class="rbcn-pro-img"><img src="@img/rbcn/rbcn_pro_4.png" alt=""></div>
            <ol v-html="this.$t('lang_labelSolution_productAdvantage_sort4_list')"></ol>
          </li>
        </ul>
      </template>
    </section>
    <section class="rbcn-display">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_platform')}}</span>
      </div>
      <div class="rbcn-description themeDesc" v-html="this.$t('lang_themeHeading_platform_narrative')"></div>
      <div class="rbcn-display-content">
        <img src="@img/rbcn/rbcn_pro_show_1.jpg" alt="" style="display:none;">
        <img src="@img/rbcn/rbcn_pro_show_2_h.jpg" alt="" style="display:none;">
        <img src="@img/rbcn/rbcn_pro_show_3_h.jpg" alt="" style="display:none;">
        <img src="@img/rbcn/rbcn_pro_show_4_h.jpg" alt="" style="display:none;">
        <div
          class="rbcn-display-item"
          :class="{'enable':PlatformShow === 'live'}"
          data-name="live" 
          @mouseover="changePlatform('live')"
        >
          <div class="rbcn-display-item-inner">
            <h2>{{this.$t('lang_live2')}}</h2>
            <h3 v-html="this.$t('lang_platform_live_msg')"></h3>
            <ul class="rbcn-display-logo">
              <li><img src="@img/rbcn/logo_bb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ag.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_pt.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ab.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_gd.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ea.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_bg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_n2.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_wm.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_evo.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_og.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ae.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_xg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ez.png" alt="" ></li>
            </ul>
          </div>
        </div>
        <div
          class="rbcn-display-item"
          :class="{'enable':PlatformShow === 'slot'}" 
          data-name="slot" 
          @mouseover="changePlatform('slot')"
        >
          <div class="rbcn-display-item-inner">
            <h2>{{this.$t('lang_slot2')}}</h2>
            <h3 v-html="this.$t('lang_platform_slot_msg')"></h3>
            <ul class="rbcn-display-logo">
              <li><img src="@img/rbcn/logo_mg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_fb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_bb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_pt.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ag.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_gg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_sp.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_jdb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_gp.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_r88.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_cq9.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_pg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_mw.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_gps.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_fa.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_fg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_va.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_rsg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_hc.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_yl.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ae.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_tp.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ron.png" alt="" ></li>
            </ul>
          </div>
        </div>
        <div
          class="rbcn-display-item"
          :class="{'enable':PlatformShow === 'sport'}" 
          data-name="sport" 
          @mouseover="changePlatform('sport')"
        >
          <div class="rbcn-display-item-inner">
            <h2>{{this.$t('lang_sport2')}}</h2>
            <h3 v-html="this.$t('lang_platform_sport_msg')"></h3>
            <ul class="rbcn-display-logo">
              <li><img src="@img/rbcn/logo_cmd.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ow.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_im.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_bb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_nbb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_rsp.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ob.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_sbs.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_tfg.png" alt="" ></li>

            </ul>
          </div>
        </div>
        <div 
          class="rbcn-display-item"
          :class="{'enable':PlatformShow === 'keno'}" 
          data-name="keno" 
          @mouseover="changePlatform('keno')"
        >
          <div class="rbcn-display-item-inner">
            <h2>{{this.$t('lang_lottery2')}}</h2>
            <h3 v-html="this.$t('lang_platform_lottery_msg')"></h3>
            <ul class="rbcn-display-logo">
              <li><img src="@img/rbcn/logo_fb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_bb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_wg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_vsl.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_tc.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ap.png" alt="" ></li>
            </ul>
          </div>
        </div>
        <div 
          class="rbcn-display-item"
          :class="{'enable':PlatformShow === 'chess'}" 
          data-name="chess" 
          @mouseover="changePlatform('chess')"
        >
          <div class="rbcn-display-item-inner">
            <h2>{{this.$t('lang_chess2')}}</h2>
            <h3 v-html="this.$t('lang_platform_lottery_msg')"></h3>
            <ul class="rbcn-display-logo">
              <li><img src="@img/rbcn/logo_fb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_bb.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_wg.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_vsl.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_tc.png" alt="" ></li>
              <li><img src="@img/rbcn/logo_ap.png" alt="" ></li>
            </ul>
          </div>
        </div>
      </div>
      <ul class="rbcn-display-content-mobile">
        <li>
          <span><img src="@img/mobile/rbcn/logo_ag.png" alt="" class="logo-ag"></span>
          <span><img src="@img/mobile/rbcn/logo_pt.png" alt="" class="logo-pt"></span>
          <span><img src="@img/mobile/rbcn/logo_mg.png" alt="" class="logo-mg"></span>
        </li>
        <li>
          <span><img src="@img/mobile/rbcn/logo_bb.png" alt="" class="logo-bb"></span>
          <span><img src="@img/mobile/rbcn/logo_fb.png" alt="" class="logo-fb"></span>
          <span><img src="@img/mobile/rbcn/logo_sp.png" alt="" class="logo-sp"></span>
        </li>
        <li>
          <span><img src="@img/mobile/rbcn/logo_ow.png" alt="" class="logo-ow"></span>
          <span><img src="@img/mobile/rbcn/logo_tgp.png" alt="" class="logo-tgp"></span>
          <span><img src="@img/mobile/rbcn/logo_jdb.png" alt="" class="logo-jdb"></span>
        </li>
        <li>
          <span><img src="@img/mobile/rbcn/logo_ab.png" alt="" class="logo-ab"></span>
          <span><img src="@img/mobile/rbcn/logo_ea.png" alt="" class="logo-ea"></span>
          <span><img src="@img/mobile/rbcn/logo_gd.png" alt="" class="logo-gd"></span>
        </li>
        <li>
          <span><img src="@img/mobile/rbcn/logo_jbb.png" alt="" class="logo-jbb"></span>
          <span><img src="@img/mobile/rbcn/logo_cmd.png" alt="" class="logo-cmd"></span>
          <span><img src="@img/mobile/rbcn/logo_sb.png" alt="" class="logo-sb"></span>
        </li>
        <li>
          <span><img src="@img/mobile/rbcn/logo_gg.png" alt="" class="logo-gg"></span>
          <span><img src="@img/mobile/rbcn/logo_os.png" alt="" class="logo-os"></span>
          <span><img src="@img/mobile/rbcn/logo_gg2.png" alt="" class="logo-gg2"></span>
        </li>
      </ul>
    </section>
    <section class="rbcn-process">
      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_cooperation')}}</span>
      </div>
      <div class="rbcn-description themeDesc">
        <span v-html="this.$t('lang_themeHeading_cooperation_narrative')"></span>
      </div>
      <div class="rbcn-process-step">
        <div 
          class="rbcn-step-1"
          :class="{'enable':ProcessShow === 1}"
          data-step="1" 
          @mouseover="changeProcess(1)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-1"></i>
            <i class="sprb_step-1-hover"></i>
          </div>
          <span>{{this.$t('lang_consultation')}}</span>
          <h3>{{this.$t('lang_consultation_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-2"
          :class="{'enable':ProcessShow === 2}"
          data-step="2" 
          @mouseover="changeProcess(2)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-2"></i>
            <i class="sprb_step-2-hover"></i>
          </div>
          <span>{{this.$t('lang_contractSigning')}}</span>
          <h3>{{this.$t('lang_contractSigning_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-3"
          :class="{'enable':ProcessShow === 3}"
          data-step="3" 
          @mouseover="changeProcess(3)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-3"></i>
            <i class="sprb_step-3-hover"></i>
          </div>
          <span>{{this.$t('lang_design')}}</span>
          <h3>{{this.$t('lang_design_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-4"
          :class="{'enable':ProcessShow === 4}"
          data-step="4" 
          @mouseover="changeProcess(4)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-4"></i>
            <i class="sprb_step-4-hover"></i>
          </div>
          <span>{{this.$t('lang_siteBuilding')}}</span>
          <h3>{{this.$t('lang_siteBuilding_msg')}}</h3>
        </div
        ><div 
          class="rbcn-step-5"
          :class="{'enable':ProcessShow === 5}"
          data-step="5" 
          @mouseover="changeProcess(5)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-5"></i>
            <i class="sprb_step-5-hover"></i>
          </div>
          <span>{{this.$t('lang_revision')}}</span>
          <h3>{{this.$t('lang_revision_msg')}}</h3>
        </div
        ><div
          class="rbcn-step-6"
          :class="{'enable':ProcessShow === 6}"
          data-step="6" 
          @mouseover="changeProcess(6)"
        >
          <div class="rbcn-step-icon">
            <i class="sprb_step-6"></i>
            <i class="sprb_step-6-hover"></i>
          </div>
          <span>{{this.$t('lang_online')}}</span>
          <h3>{{this.$t('lang_online_msg')}}</h3>
        </div>
      </div>

      <div class="underLineHeading">
        <span>{{$t('lang_themeHeading_labelSpecification')}}</span>
      </div>
      <div class="specification-item">
        <div
          :class="{'enable':SpecificationShow === 1}"
          @click="changeSpecification(1)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort1')}}</span>
          <div class="specification-item-inner" v-html="this.$t('lang_label_specification_sort1_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 2}"
          @click="changeSpecification(2)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort2')}}</span>
          <div class="specification-item-inner" v-html="this.$t('lang_label_specification_sort2_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 3}"
          @click="changeSpecification(3)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort3')}}</span>
          <div class="specification-item-inner" v-html="this.$t('lang_label_specification_sort3_list')"></div>
        </div>
      </div>
      <div class="specification-item">
        <div
          :class="{'enable':SpecificationShow === 4}"
          @click="changeSpecification(4)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort4')}}</span>
          <div class="specification-item-inner" v-html="this.$t('lang_label_specification_sort4_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 5}"
          @click="changeSpecification(5)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort5')}}</span>
          <div class="specification-item-inner half clearfix" v-html="this.$t('lang_label_specification_sort5_list')"></div>
        </div>
        <div
          :class="{'enable':SpecificationShow === 6}"
          @click="changeSpecification(6)"
        >
          <span class="specification-item-name">{{this.$t('lang_specification_sort6')}}</span>
          <div class="specification-item-inner" v-html="this.$t('lang_label_specification_sort6_list')"></div>
        </div>
      </div>
    </section>
    <section class="rbcn-contact">
      <span>
        <router-link to="/rblt"><i v-html="$t('lang_know_lotterySolution')"></i></router-link>
        <router-link to="/contact" class="primary"><i>{{this.$t('lang_knowMore')}}</i></router-link>
        <router-link to="/develop"><i>{{this.$t('lang_know_gameConnet')}}</i></router-link>
      </span>
    </section>
  </div>
</template>

<script>
import $ from 'jquery'
import { Carousel, Slide } from 'vue-carousel';
export default {
  name: 'Rbcn',
	components: {
    Carousel,
    Slide
  },
  data(){
    return{
      PlatformShow: 'live',
      ProcessShow: 1,
      SpecificationShow: 1,
      isMobile: false,
    }
  },
  methods:{
    changePlatform(value){
      this.PlatformShow = value
    },
    changeProcess(value){
      this.ProcessShow = value
    },
    changeSpecification(value){
      this.SpecificationShow = value
    },
    getWinSize(){
			const $this = this;
			$(window).resize(function(){
				$this.isMobile = $(window).width() > 996 ? false : true
			})
			$this.isMobile = $(window).width() > 996 ? false : true
		},
		nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    }
  },
  mounted(){
    this.getWinSize()
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>
<style lang="sass">
  @import '@css/rbcn.sass'
</style>